export type GPTModel =
  | 'gpt-3.5-turbo'
  | 'gpt-3.5-turbo-0613'
  | 'gpt-3.5-turbo-16k'
  | 'gpt-3.5-turbo-16k-0613'
  | 'gpt-3.5-turbo-1106'
  | 'gpt-3.5-turbo-0125'
  | 'gpt-4'
  | 'gpt-4-0613'
  | 'gpt-4-1106-preview'
  | 'gpt-4-0125-preview'

export const kDefaultModel = 'gpt-3.5-turbo-1106'

type GPTModelMap = { [key: string]: GPTModel }

/**
 * This is a map of the GPT model to use for each function / context.
 * We choose to explicitly name each model for clarity and to make it
 * easier to change the model used for a given context.
 */
export const kGPTModelMap = {
  digDeeper: 'gpt-4-1106-preview',
  generatePrompts: 'gpt-4-0613',
  generateTopicPrompts: 'gpt-3.5-turbo-1106',
  entryReflection: 'gpt-4-1106-preview',
  suggestCommitments: 'gpt-4-1106-preview',
  weeklyReport: 'gpt-4-1106-preview',
  extractEntities: 'gpt-4-1106-preview',
  generatePersonalPrompts: 'gpt-4-0613',
  passThru: 'gpt-3.5-turbo-1106',
  generateTopics: 'gpt-3.5-turbo-0125',
  generateContent: 'gpt-4-1106-preview',
  generateContentFree: 'gpt-3.5-turbo-1106', // Save money on free users
  compressEntries: 'gpt-3.5-turbo-16k', // Does a better and more consistent job of compression than 0613
  summarizeTopic: 'gpt-4-1106-preview',
  generateOutput: 'gpt-4-1106-preview',
} as const satisfies GPTModelMap

// Create a type derived from the keys of the GPTModelMap
export type ModelContextKey = keyof typeof kGPTModelMap
